/*
 * Combine all reducers in this file and export the combined reducers.
 */
import * as redux from 'redux';
import registrationReducer from './containers/RegisterCustomer/reducer.es6';
import loginReducer from './containers/Login/reducer.es6';
import searchCustomerByMsisdnReducer from './containers/Search/reducer.es6';
import currentCustomerReducer from './containers/Customer/reducer.es6';
import customerStatusReducer from './containers/CustomerStatus/reducer.es6';
import policyPurchaseReducer from './containers/BuyPolicy/reducer.es6';
import claimSubmissionReducer from './containers/ClaimSubmission/reducer.es6';
import policyListReducer from './containers/PolicyList/reducer.es6';
import profileReducer from './containers/Profile/reducer.es6';
import updateLanguageReducer from './containers/Main/reducer.es6';
import mainLoaderReducer from './lib/loaderReducer.es6';
import openClaimReducer from './containers/ClaimsOpen/reducer.es6';
import payableClaimReducer from './containers/ClaimsPayable/reducer.es6';
import closedClaimReducer from './containers/ClaimsClosed/reducer.es6';
import claimStatusReducer from './containers/ClaimsStatus/reducer.es6';
import summaryClaimReducer from './containers/ClaimsDashboard/reducer.es6';
import processingClaimReducer from './containers/ClaimsProcessing/reducer.es6';
import userAdminReducer from './containers/Users/reducer.es6';
import claimCallbackReducer from './containers/ClaimCallback/reducer.es6';
import bulkSmsReducer from './containers/BulkSms/reducer.es6';
import countryReducer from './containers/Country/reducer.es6';
import languagesReducer from './containers/Languages/reducer.es6';
import partnersReducer from './containers/Partners/reducer.es6';
import productsReducer from './containers/ProductList/reducer.es6';
import productPremiumsReducer from './containers/ProductPremiums/reducer.es6';
import manualPaymentReducer from './containers/ManualPayment/reducer.es6';
import smsTemplatesReducer from './containers/SmsTemplate/reducer.es6'
import engineFlowsReducer from './containers/EngineFlows/reducer.es6'
import ussdSessionsReducer from './partner-apps/OldMutualMalawi/UssdSessions/Redux/reducers'
import taxConfigsReducer from './containers/TaxConfigs/reducer.es6'
import amlConfigsReducer from './containers/AmlConfigs/reducer.es6'
import riskConfigsReducer from './containers/RiskConfigs/reducer.es6'
import iprsConfigsReducer from './containers/IprsConfigs/reducer.es6'
import gatewayConfigsReducer from './containers/GatewayConfigs/reducer.es6'
import engineConfigsReducer from './containers/EngineConfigs/reducer.es6'
import manualRemittancesReducer from "./containers/ManualRemittance/reducer.es6";
import cashbackReducer from './containers/Cashback/reducer.es6';
import loyaltyUploadReducer from './containers/LoyaltyEligibility/reducer.es6';
import newProductsReducer from './containers/NewProductList/reducer.es6';
import genericProductsReducer from './containers/GenericProductConfig/reducer.es6.js';
import partnerStatusReducer from './containers/PartnerStatus/reducer.es6';
import customerDependantsReducer from "./containers/DependantsList/reducer.es6";
import customerDocumentsReducer from "./containers/CustomerFiles/reducer.es6";
import newDebitOrderReducer from './containers/CustomerScreen/components/DebitOrder/state/reducer.es6';
import customerScreenReducer from './containers/CustomerScreen/reducer.es6';
import customerbeneficiarysReducer from "./containers/BeneficiaryList/reducers"
import customerBeneficiarybankdetailsReducer from "./containers/BeneficiaryBankDetailsList/reducers"
import customerbankdetailsReducer from "./containers/CustomerBankDetailsList/Reducers"
import quoteReducer from './containers/Policyv2/Redux/reducer.es6';
import customerStatusv2Reducer from './containers/PolicyV2CustomerStatus/Redux/reducers.js'
import claimInitiationReducer from './containers/ClaimInitiationv2/Redux/reducers.js'
import claimDashboardReducer from './containers/ClaimDashboardv2/Redux/reducers.js';
import claimProcessingV2Reducer from './containers/ClaimsProcessingV2/Redux/reducers.js'
import documentGeneration from './containers/DocumentGeneration/reducer.es6';
import LouReducer from './partner-apps/ktda/PreAuth/Redux/reducers';
import bulkPolicyOnboardingReducer from './partner-apps/ktda/BulkPolicyOnboarding/Redux/reducers'
import claimDashboardBulkApproveReducer from './partner-apps/ktda/ClaimDashboard/Redux/reducers';
import bulkPaymentsReducer from './partner-apps/ktda/BulkPayments/Redux/reducers';
import drawerReducer from './containers/Drawer/redux/reducers';

import featureFlags from './containers/FeatureFlags/reducer.es6.js';
import coverLinkSettings from './containers/CoverLinkSettings/reducer.es6.js';
import AccessBankRegistrationReducer from './partner-apps/AccessBank/CustomerStatus/Containers/RegisterCustomer/redux/reducers.js'
import policiesDashboardReducer from './partner-apps/AccessBank/PoliciesDashboard/Redux/reducers.js'
import policyProcessingReducer from './partner-apps/AccessBank/PoliciesProcessing/Redux/reducers.js'
import customerStatusAccessBankReducer from './partner-apps/AccessBank/CustomerStatus/Redux/reducers.js'
import paymentsDashboardReducer from './partner-apps/AccessBank/PaymentsDashboard/Redux/reducers.js'
import paymentProcessingReducer from './partner-apps/AccessBank/PaymentProcessing/Redux/reducers.js'
import accessBankQuoteReducer from './partner-apps/AccessBank/CustomerStatus/Containers/Quotes/Redux/reducers.js'
import accessBankPremiumsReducer from './partner-apps/AccessBank/CustomerStatus/Containers/Premiums/Redux/reducers.js'
import accessBankClaimsReducer from './partner-apps/AccessBank/CustomerStatus/Containers/Claims/redux/reducers.js'
import accessBankSmsActivityReducer from './partner-apps/AccessBank/CustomerStatus/Containers/SmsActivity/Redux/reducers.js'
import policyCancellationReducer from './partner-apps/Samba/PolicyCancellation/Redux/reducers.js'
import emailTemplatesReducer from './containers/EmailTemplates/Redux/reducer.js'
import reportsTemplatesReducer from './containers/ReportsConfigs/Redux/reducer.js'
import generateReportReducer from './containers/Reports/Redux/reducer.js'
import knowledgeBaseReducer from './components/KnowledgeBase/Redux/reducer.js';
import elasticSearchReducer from './containers/ElasticSearch/Redux/reducers.js';
import webhookSubscriptionsReducer from './containers/WebhookSubscriptions/reducer.es6';
import customerStatusNGSGroupReducer from './partner-apps/NgsUganda/CustomerStatus/Redux/reducers.js'
import NGSGroupQuoteReducer from './partner-apps/NgsUganda/CustomerStatus/Container/Quotes/Redux/reducers.js'
import ngsGroupClaimsReducer from './partner-apps/NgsUganda/CustomerStatus/Container/Claims/redux/reducers.js'
import auditsReducer from './containers/Audits/Redux/reducers.js';
import IncMotorquoteReducer from './partner-apps/InclMotor/PolicyAdmin/Redux/reducer.es6.js'
import DcpRegistrationReducer from './partner-apps/MalipoWws/CustomerStatus/Containers/RegisterCustomer/redux/reducers.js'
import claimProcessingCoverLinkReducer from './partner-apps/CoverLink/ClaimProcessing/Redux/reducers.js'
import claimDashboardCoverLinkReducer from './partner-apps/CoverLink/ClaimDashboard/Redux/reducers.js'
import recentPoliciesReducer from './components/RecentPolicies/Redux/reducer.js'
import recentPaymentsReducer from './components/RecentPayments/Redux/reducer.js'
import organizationsReducer from './containers/Organizations/Redux/reducers.js'
import orgProductTemplatesReducer from './containers/OrganizationProductTemplates/Redux/reducers.js'
import orgEmailTemplatesReducer from './containers/OrganizationEmailTemplates/Redux/reducers.js'
import orgSmsTemplatesReducer from './containers/OrganizationSmsTemplates/Redux/reducers.js'
import orgWebhookTemplatesReducer from './containers/OrganizationWebhookTemplates/Redux/reducers.js'
import orgConfigReducer from './containers/OrgConfig/Redux/reducers.js'
import orgIppConfigsReducer from './containers/OrganizationIppConfigs/Redux/reducers.js'
import orgClaimInitConfigsReducer from './containers/OrganizationClaimInitiation/Redux/reducers.js'
import orgCustomerStatusConfigsReducer from './containers/OrganizationCustomerStatus/Redux/reducers.js'
import orgClaimProcConfigsReducer from './containers/OrganizationClaimProcessing/Redux/reducers.js'
import commissionAgentsReducer from './containers/CommissionAgents/reducer.es6';
import commissionAgenciesReducer from './containers/CommissionAgencies/reducer.es6';
import commissionRulesReducer from './containers/CommissionRules/reducer.es6';
import clawbackRulesReducer from './containers/ClawbackRules/reducer.es6';
import commissionTransactionsReducer from './containers/CommissionTransactions/reducer.es6';
import commissionStatementReducer from './containers/CommissionTransactions/statement/reducer.es6';
import commissionAccountsReducer from './containers/CommissionAccounts/reducer.es6';
import batchPayoutsReducer from './containers/BatchPayouts/reducer.es6';
import commissionSettingsReducer from './containers/CommissionSettings/reducer.es6';
import omgGroupApprovalReducer from './partner-apps/OldMutualKenya/GroupApprovalDashboard/Redux/reducers';
import omkGroupPaymentReducer from './partner-apps/OldMutualKenya/GroupPaymentDashboard/Redux/reducers';
// Return a function to create the main reducer
export default function createReducer() {
  // connecting the explorer page state/store to its corresponding reducer
  return redux.combineReducers({
    customerRegistration: registrationReducer,
    login: loginReducer,
    policyPurchase: policyPurchaseReducer,
    search: searchCustomerByMsisdnReducer,
    currentCustomer: currentCustomerReducer, // Needs to map the tag in reducer initialstate
    customerStatus: customerStatusReducer,
    claimRequest: claimSubmissionReducer,
    policyList: policyListReducer,
    loader: mainLoaderReducer,
    profile: profileReducer,
    global: updateLanguageReducer,
    openClaimsList: openClaimReducer,
    payableClaimsList: payableClaimReducer,
    closedClaimsList: closedClaimReducer,
    claimsSummariesList: summaryClaimReducer,
    claimsStatusList: claimStatusReducer,
    processingClaim: processingClaimReducer,
    userAdmin: userAdminReducer,
    claimsCallBack: claimCallbackReducer,
    bulkSms: bulkSmsReducer,
    country: countryReducer,
    languages: languagesReducer,
    partners: partnersReducer,
    products: productsReducer,
    productPremiums: productPremiumsReducer,
    manualPayment: manualPaymentReducer,
    smsTemplates: smsTemplatesReducer,
    engineFlows: engineFlowsReducer,
    ussdSessions: ussdSessionsReducer,
    taxConfigs: taxConfigsReducer,
    amlConfigs: amlConfigsReducer,
    riskConfigs: riskConfigsReducer,
    iprsConfigs: iprsConfigsReducer,
    gatewayConfigs: gatewayConfigsReducer,
    engineConfigs: engineConfigsReducer,
    remittances: manualRemittancesReducer,
    cashback: cashbackReducer,
    loyaltyUpload: loyaltyUploadReducer,
    newProducts: newProductsReducer,
    genericProducts: genericProductsReducer,
    partnerStatus: partnerStatusReducer,
    customerBeneficiary: customerbeneficiarysReducer,
    customerDependants: customerDependantsReducer,
    customerDocuments: customerDocumentsReducer,
    newDebitOrder: newDebitOrderReducer,
    customerScreen: customerScreenReducer,
    customerBeneficiarybankdetails: customerBeneficiarybankdetailsReducer,
    customerbankdetails: customerbankdetailsReducer,
    quoteData: quoteReducer,
    customerStatusV2Data: customerStatusv2Reducer,
    claimInitiationData: claimInitiationReducer,
    claimDashboardData: claimDashboardReducer,
    claimProcessingv2Data: claimProcessingV2Reducer,
    documentGeneration: documentGeneration,
    LouData: LouReducer,
    bulkPolicyOnboarding: bulkPolicyOnboardingReducer,
    bulkApprovalData: claimDashboardBulkApproveReducer,
    bulkPayments: bulkPaymentsReducer,
    drawerData: drawerReducer,
    featureFlags: featureFlags,
    coverLinkSettings: coverLinkSettings,
    AccessBankRegistrationData: AccessBankRegistrationReducer,
    PoliciesDashboardData: policiesDashboardReducer,
    PolicyProcessingData: policyProcessingReducer,
    AccessBankPolicyData: customerStatusAccessBankReducer,
    PaymentsDashboardData: paymentsDashboardReducer,
    PaymentProcessingData: paymentProcessingReducer,
    AccessBankQuoteData: accessBankQuoteReducer,
    AccessBankPremiumData: accessBankPremiumsReducer,
    AccessBankClaimsData: accessBankClaimsReducer,
    AccessBankSmsActivityData: accessBankSmsActivityReducer,
    emailTemplates: emailTemplatesReducer,
    ReportsTemplateData: reportsTemplatesReducer,
    GenerateReportData: generateReportReducer,
    knowledgeBaseState: knowledgeBaseReducer,
    elasticSearchData: elasticSearchReducer,
    NGSGroupcustomerStatusData: customerStatusNGSGroupReducer,
    NGSGroupQuoteData: NGSGroupQuoteReducer,
    NGSGroupClaimsData: ngsGroupClaimsReducer,
    auditState: auditsReducer,
    incMotorData: IncMotorquoteReducer,
    DCPRegistrationData: DcpRegistrationReducer,
    ClaimProcessingCoverLinkData: claimProcessingCoverLinkReducer,
    ClaimDashboardCoverLinkData: claimDashboardCoverLinkReducer,
    recentPoliciesData: recentPoliciesReducer,
    recentPaymentsData: recentPaymentsReducer,
    policyCancellationData: policyCancellationReducer,
    webhookSubscriptions: webhookSubscriptionsReducer,
    organizationsData: organizationsReducer,
    orgProductTemplatesData: orgProductTemplatesReducer,
    orgEmailTemplatesData: orgEmailTemplatesReducer,
    orgSmsTemplatesData: orgSmsTemplatesReducer,
    orgWebhookTemplatesData: orgWebhookTemplatesReducer,
    orgConfigData: orgConfigReducer,
    orgIppConfigsData: orgIppConfigsReducer,
    orgClaimInitConfigsData: orgClaimInitConfigsReducer,
    orgCustomerStatusConfigsData: orgCustomerStatusConfigsReducer,
    orgClaimProcConfigsData: orgClaimProcConfigsReducer,
    commissionAgents: commissionAgentsReducer,
    commissionAgencies: commissionAgenciesReducer,
    commissionRules: commissionRulesReducer,
    clawbackRules: clawbackRulesReducer,
    commissionTransactions: commissionTransactionsReducer,
    commissionStatement: commissionStatementReducer,
    commissionAccounts: commissionAccountsReducer,
    batchPayouts: batchPayoutsReducer,
    commissionSettings: commissionSettingsReducer,
    omgGroupApprovalData: omgGroupApprovalReducer,
    omkGroupPaymentData: omkGroupPaymentReducer,
  });
}
